import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { isKeyCapsLock } from "../../../lib/events/keyboard/identifiers";
import { KeyboardEventCodes as Codes } from "../../../lib/events/keyboard/KeyboardEventCodes";
import { Input } from "../../Input";
import { EyeClosedIcon, EyeOpenedIcon } from "../../../internal/icons/16px";
import { isIE11 } from "../../../lib/client";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../PasswordInput.styles";
/**
 * Компонент для ввода пароля
 */

export var PasswordInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PasswordInput, _React$Component);

  function PasswordInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      visible: false,
      capsLockEnabled: false
    };
    _this.theme = void 0;
    _this.input = void 0;

    _this.focus = function () {
      if (_this.input) {
        _this.input.focus();
      }
    };

    _this.blur = function () {
      _this.handleBlur();
    };

    _this.handleKeyPress = function (e) {
      var _this$props = _this.props,
          onKeyPress = _this$props.onKeyPress,
          detectCapsLock = _this$props.detectCapsLock;

      if (onKeyPress) {
        onKeyPress(e);
      }

      if (!detectCapsLock) {
        return;
      }

      var capsLockEnabled = e.getModifierState(Codes.CapsLock);

      _this.setState({
        capsLockEnabled: capsLockEnabled
      });
    };

    _this.handleKeydown = function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          _assertThisInitialize2 = _assertThisInitialize.props,
          detectCapsLock = _assertThisInitialize2.detectCapsLock,
          onKeyDown = _assertThisInitialize2.onKeyDown,
          capsLockEnabled = _assertThisInitialize.state.capsLockEnabled;

      if (onKeyDown) {
        onKeyDown(e);
      }

      if (!detectCapsLock) {
        return;
      }

      if (isKeyCapsLock(e) && capsLockEnabled != null) {
        _this.setState({
          capsLockEnabled: !capsLockEnabled
        });
      }
    };

    _this.handleToggleVisibility = function () {
      _this.setState(function (prevState) {
        return {
          visible: !prevState.visible
        };
      }, _this.handleFocus);
    };

    _this.handleFocus = function () {
      if (_this.input) {
        _this.input.focus();
      }
    };

    _this.handleBlur = function () {
      if (_this.input) {
        _this.input.blur();
      }
    };

    _this.renderEye = function () {
      var capsLockEnabled = _this.state.capsLockEnabled;
      return /*#__PURE__*/React.createElement("span", {
        className: styles.iconWrapper()
      }, capsLockEnabled && /*#__PURE__*/React.createElement("span", {
        className: styles.capsLockDetector(),
        "data-tid": "PasswordInputCapsLockDetector"
      }), /*#__PURE__*/React.createElement("span", {
        "data-tid": "PasswordInputEyeIcon",
        className: cx(styles.toggleVisibility(), _this.getEyeWrapperClassname()),
        onClick: _this.handleToggleVisibility
      }, _this.state.visible ? /*#__PURE__*/React.createElement(EyeClosedIcon, {
        size: 14
      }) : /*#__PURE__*/React.createElement(EyeOpenedIcon, {
        size: 14
      })));
    };

    _this.refInput = function (element) {
      _this.input = element;
    };

    _this.renderMain = function (props) {
      var detectCapsLock = props.detectCapsLock,
          rest = _objectWithoutPropertiesLoose(props, ["detectCapsLock"]);

      var inputProps = _extends({}, rest, {
        onKeyDown: _this.handleKeydown,
        onKeyPress: _this.handleKeyPress,
        rightIcon: _this.renderEye()
      });

      return /*#__PURE__*/React.createElement("div", {
        className: styles.root()
      }, /*#__PURE__*/React.createElement(Input, _extends({
        ref: _this.refInput,
        type: _this.state.visible ? 'text' : 'password'
      }, inputProps)));
    };

    return _this;
  }

  var _proto = PasswordInput.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    if (this.props.detectCapsLock) {
      this.setState({
        capsLockEnabled: null
      });
    } // @ts-ignore


    if (isIE11 && !window.document.msCapsLockWarningOff) {
      // turns off default ie capslock warning
      // @ts-ignore
      window.document.msCapsLockWarningOff = true;
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  }
  /**
  * @public
  */
  ;

  _proto.getEyeWrapperClassname = function getEyeWrapperClassname(right) {
    if (right === void 0) {
      right = false;
    }

    switch (this.props.size) {
      case 'large':
        return styles.eyeWrapperLarge(this.theme);

      case 'medium':
        return styles.eyeWrapperMedium(this.theme);

      case 'small':
      default:
        return styles.eyeWrapperSmall(this.theme);
    }
  };

  return PasswordInput;
}(React.Component);
PasswordInput.__KONTUR_REACT_UI__ = 'PasswordInput';
PasswordInput.propTypes = {
  /**
  * Включает CapsLock детектор
  */
  detectCapsLock: PropTypes.bool
};
PasswordInput.defaultProps = {
  size: 'small'
};